// extracted by mini-css-extract-plugin
module.exports = {"page":"video-preview_page__2jStX","pageContent":"video-preview_pageContent__E6ebQ","main":"video-preview_main__3sgBN","mainContent":"video-preview_mainContent__3Y34o"};